let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eFOoe")).then(() => parcelRequire('dv9oa'));